const testimonials = [
  {
    name: "Anna B.",
    location: "Coeur d'Alene, ID",
    rating: 5,
    text: "My husband and I were planning a cruise from Vancouver and both our passports had expired. Fast Passport Center got both renewals done in 7 days total. Saved our vacation and saved us a trip to Seattle.",
    service: "Expedited Renewal",
  },
  {
    name: "Tyler N.",
    location: "Post Falls, ID",
    rating: 5,
    text: "First passport ever and I had no idea where to go. They helped me find the Kootenai County Clerk location, gave me a checklist, and had my passport ready before my Costa Rica trip. Amazing service.",
    service: "New Application",
  },
  {
    name: "Karen S.",
    location: "Hayden, ID",
    rating: 5,
    text: "Lost my passport 3 weeks before a work trip to Europe. Their team handled everything — DS-64, new DS-11, the whole thing. Passport arrived in 5 business days. Cannot recommend them enough.",
    service: "Lost Passport",
  },
];

export default function TestimonialsSection() {
  return (
    <section id="reviews" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Coeur d&apos;Alene Travelers Are Saying
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base leading-relaxed">
            Real customers from Coeur d&apos;Alene, Post Falls, Hayden, Sandpoint, and the surrounding area.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6">
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#F6C344] text-sm"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-4 italic">&ldquo;{t.text}&rdquo;</p>
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="bg-[#EEF2F8] text-[#1A365D] text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}